import React from 'react'

export const TranscriptionIcon = ({ color = 'white', ...props }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      color={color}
      {...props}
    >
      <rect
        x='4.5'
        y='7'
        width='15'
        height='1.5'
        rx='0.75'
        fill='currentColor'
      />
      <rect
        x='4.5'
        y='11.5'
        width='15'
        height='1.5'
        rx='0.75'
        fill='currentColor'
      />
      <rect
        x='4.5'
        y='16.5'
        width='10'
        height='1.5'
        rx='0.75'
        fill='currentColor'
      />
    </svg>
  )
}
